var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.525 4.0001C9.93718 4.0001 8.65 5.28728 8.65 6.8751C8.65 8.46292 9.93718 9.7501 11.525 9.7501C13.1128 9.7501 14.4 8.46292 14.4 6.8751C14.4 5.28728 13.1128 4.0001 11.525 4.0001ZM11.525 2.8501C9.30205 2.8501 7.5 4.65215 7.5 6.8751C7.5 9.09804 9.30205 10.9001 11.525 10.9001C13.7479 10.9001 15.55 9.09804 15.55 6.8751C15.55 4.65215 13.7479 2.8501 11.525 2.8501Z",
    fill: "#555555",
    stroke: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4999 12.8623C12.5545 12.8623 15.444 13.0827 16.9704 14.7391C18.2914 16.1749 18.8294 18.5333 18.9965 19.979C19.0068 20.0909 18.9943 20.2038 18.9596 20.3104C18.925 20.417 18.869 20.5151 18.7953 20.5982C18.7216 20.6814 18.6317 20.7478 18.5315 20.7933C18.4313 20.8388 18.323 20.8623 18.2134 20.8623H4.78713C4.67732 20.8631 4.56858 20.8401 4.46799 20.7949C4.36741 20.7497 4.27723 20.6833 4.20335 20.6C4.12947 20.5166 4.07354 20.4183 4.0392 20.3113C4.00486 20.2043 3.99288 20.0911 4.00405 19.979C4.17038 18.5333 4.7047 16.1734 6.02944 14.7391C7.55658 13.0835 10.4453 12.8623 11.4999 12.8623ZM16.0586 15.5249C14.7866 14.1791 12.3788 14 11.4999 14C10.621 14 8.21381 14.1797 6.9412 15.5249C5.89266 16.6318 5.43835 18.4171 5.27661 19.6H17.7237C17.5612 18.4172 17.1042 16.6329 16.0586 15.5249Z",
    fill: "#555555",
    stroke: "#555555"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOutlined);
export default __webpack_public_path__ + "static/media/user-outlined.ddbbef36.svg";
export { ForwardRef as ReactComponent };